module.exports = require("date-fns/get_month");


//////////////////
// WEBPACK FOOTER
// external "date-fns/get_month"
// module id = 41
// module chunks = 0